import { QueryKey } from '@/configs/queryKeys';
import { AppUser } from '@/types/user';
import httpClient from './httpClient';

export type UpdateUserPayload = Partial<{
	firstName: string;
	lastName: string;
	email: string;
	password: string;
	oldPassword: string;
}>;

class UserApi {
	queryKey = QueryKey.me;

	constructor() {
		this.update = this.update.bind(this);
	}

	async getCurrentUser() {
		const response = await httpClient.get<AppUser>(this.queryKey);
		return response.data;
	}

	async update(payload: UpdateUserPayload) {
		const response = await httpClient.patch<AppUser>(this.queryKey, payload);
		return response.data;
	}
}

export default new UserApi();
